import PropTypes from "prop-types";

import { listIconProps } from "NavBar/styleConstants";

import FnrContainedIcon from "UI/FnrContainedIcon";

const ICONS_BY_SIGNUP_TYPE = Object.freeze({
  1: "calendar fas",
  2: "ticket fas",
  4: "check-square fas",
  5: "tasks fas",
  7: "users fas",
});

function SignupIcon({ signupListTypeID }) {
  return (
    <FnrContainedIcon
      {...listIconProps}
      icon={ICONS_BY_SIGNUP_TYPE[signupListTypeID]}
      size="md"
    />
  );
}

SignupIcon.propTypes = {
  signupListTypeID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SignupIcon;
